import Skeleton from 'react-loading-skeleton';
import React from 'react';

const CommentSkeleton = () => {
  return (
    <div className="tw-mb-3 tw-flex tw-items-end tw-justify-end tw-space-x-2">
      <div className="tw-flex tw-flex-col tw-items-end">
        <Skeleton width={125} style={{ borderRadius: 5, height: 16 }} />
        <Skeleton width={200} style={{ borderRadius: 16, height: 32 }} />
      </div>
      <Skeleton width={32} style={{ borderRadius: '100%', height: 32 }} />
    </div>
  );
};

export default CommentSkeleton;
